
import React from 'react';
import { AuthenticatedApp } from '../../components/Root/AuthenticatedApp';
import { NavigationForSmallScreen } from '../../components/NavigationPanel/NavigationForSmallScreen';


export const HEIGHT_BOTTOM_TAB_BAR = 0;






export default function Layout(){
  return (

    <AuthenticatedApp>
      <NavigationForSmallScreen />

    </AuthenticatedApp>
  );
}


